<template>
  <div class="courseRecord">
    <div class="courseRecord-search">
      <div>
        <span>课程名称：</span>
        <el-input placeholder="请输入课程名称" />
      </div>
      <div>
        <span>区县：</span>
        <el-select
          v-model="areaCode"
          placeholder="请选择"
          @change="selectArea"
        >
          <el-option
            v-for="item in areaList"
            :key="item.areaCode"
            :label="item.areaName"
            :value="item.areaCode"
          />
        </el-select>
      </div>
      <div>
        <span>学校名称：</span>
        <el-input
          v-model="schoolName"
          placeholder="请输入学校名称"
        />
      </div>
      <div>
        <span>身份证号：</span>
        <el-input
          v-model="idCardNum"
          placeholder="请输入身份证号"
        />
      </div>
      <div>
        <el-button
          type="primary"
          size="small"
          @click="search"
        >查 询</el-button>
        <el-button
          plain
          size="small"
          @click="reset"
        >重 置</el-button>
        <el-button
          plain
          size="small"
          :loading="loadiong"
          @click="exportExcel"
        >导 出</el-button>
      </div>
    </div>
    <div class="courseRecord-tableHead">
      <div>
        <div class="subTitle">课程名称</div>
        <div class="subText">{{ queryData.name }}</div>
      </div>
      <div>
        <div class="subTitle">主讲老师</div>
        <div class="content">{{ queryData.teacherName }}</div>
        <div class="subTitle">上传日期</div>
        <div class="content">{{ queryData.updateTime }}</div>
      </div>
    </div>
    <div class="courseRecord-table">
      <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style="{ background: '#fafafa' }"
        style="width: 100%"
      >
        <el-table-column
          label="序号"
          type="index"
          width="50"
          align="center"
        />
        <el-table-column
          prop="areaName"
          label="区县"
          show-overflow-tooltip
        />
        <el-table-column
          prop="schoolName"
          label="学校名称"
          show-overflow-tooltip
        />
        <el-table-column
          prop="teacherName"
          label="教师姓名"
          show-overflow-tooltip
        />
        <el-table-column
          prop="idCardNum"
          label="身份证号"
          width="180"
        />
        <el-table-column
          prop="phone"
          label="手机号"
        />
        <el-table-column
          prop="playTime"
          label="观看日期"
        />
      </el-table>
    </div>
    <div class="courseRecord-pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { downLoadFile } from "@/utils/downLoad";
import { getAreaList, getViewList } from "@/api/course";
export default {
  data() {
    return {
      areaCode: "",
      areaName: "",
      idCardNum: "",
      schoolName: "",
      page: 1,
      size: 10,
      total: 0,
      areaList: [],
      tableData: [],
      queryData: {},
      loadiong: false
    };
  },
  mounted() {
    if (this.$route.query.data) {
      this.queryData = JSON.parse(this.$route.query.data);
    }
    this.getAreaList();
    this.getViewList();
  },
  methods: {
    search() {
      this.page = 1;
      this.getViewList();
    },
    reset() {
      this.page = 1;
      this.areaName = "";
      this.areaCode = "";
      this.idCardNum = "";
      this.schoolName = "";
      this.getViewList();
    },
    exportExcel() {
      this.loadiong = true;
      let data = {
        areaCode: this.areaCode,
        areaName: this.areaName,
        idCardNum: this.idCardNum,
        page: this.page,
        size: this.size,
        videoId: this.queryData.id,
        schoolName: this.schoolName
      };
      axios({
        method: "post",
        url: `${process.env.VUE_APP_URL}/video-course/api/view/export`,
        data,
        responseType: "blob"
      }).then(res => {
        let name = `${this.queryData.name}观看记录统计表`;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(res.data, `${name}.xlsx`);
        } else {
          downLoadFile(res.data, name);
        }
        this.loadiong = false;
      });
    },
    selectArea(val) {
      this.areaList.map(ele => {
        if (ele.areaCode === val) this.areaName = ele.areaName;
      });
    },
    getAreaList() {
      getAreaList().then(res => {
        this.areaList = res;
      });
    },
    getViewList() {
      let data = {
        areaCode: this.areaCode,
        areaName: this.areaName,
        idCardNum: this.idCardNum,
        page: this.page,
        size: this.size,
        videoId: this.queryData.id,
        schoolName: this.schoolName
      };
      getViewList(data).then(res => {
        this.tableData = res.viewRecordDtoList;
        this.total = res.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.courseRecord {
  padding: 20px 15% 40px 15%;
  &-search {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      ::v-deep.el-input__inner,
      .el-input {
        height: 32px;
        width: 180px;
      }
    }
  }
  &-tableHead {
    margin-top: 20px;
    > div {
      display: flex;
      height: 40px;
      align-items: center;
      text-align: center;
      border: 1px solid #ccc;
      margin-top: -1px;
      background-color: #fafafb;
      > div {
        height: 40px;
        line-height: 40px;
      }
      .subTitle {
        background-color: #f0f1f4;
        width: 25%;
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
        margin-right: -1px;
        margin-left: -1px;
      }
      .content {
        width: 23%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 1%;
      }
      .subText {
        padding: 0 1%;
        width: 73%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  &-table {
    // margin-top: 20px;
    border: 1px solid #ccc;
    border-top: none;
  }
  &-pagination {
    padding: 40px 0;
    text-align: center;
  }
}
</style>

